export default __webpack_public_path__ + "e940097d2af00f712a9f490b35e7f1a2.png";